/** @format */

import { useContext } from 'react';
import PropTypes from 'prop-types';

import { EventContext } from '../../Contexts/EventContext';

const SidebarForm = ({ addFieldToForm }) => {
	const eventContext = useContext(EventContext);
	console.log(eventContext);
	return (
		<aside className='w-100 rounded-1 overflow-hidden mt-1 p-2'>
			<div className='bg-persian-green sidebar-header p-2 text-center'>
				<h1 className='text-dark-mode f-14 font-weight-bold'>فرم ساز</h1>
			</div>
			<ul className='d-flex flex-column nav border border-info p-2 '>
				{eventContext.fields.map((item) => (
					<li
						onClick={() => addFieldToForm(item)}
						className='border-bottom p-2 c-pointer d-flex flex-row justify-content-between'
						key={item.id}>
						<span className='mx-2'>{item.label}</span>
						{eventContext.formBuilderFieldsData?.find(
							(f) => f.name === item.name,
						) ? (
							<i className='fad fa-check text-success f-16'></i>
						) : (
							<i className='fad fa-plus f-16'></i>
						)}
					</li>
				))}
			</ul>
		</aside>
	);
};

SidebarForm.propTypes = {
	addFieldToForm: PropTypes.func,
};

export default SidebarForm;
